<template>
  <v-container>
    <OrganizationEditionForm
      :uuid="organization.uuid ? organization.uuid: ''"
      :name="organization.name ? organization.name: ''"
      v-on:save="updateOrganization"
      ref="organizationEditionForm"
    />
    <v-divider class="mb-6"></v-divider>
    <v-btn color="primary" icon @click="refreshUsers">
      <v-icon>refresh</v-icon>
    </v-btn>
    <OrganizationUsers
      :adminUsers="admins ? admins : []"
      :users="users ? users : []"
      v-on:addUser="addAdminToOrganization"
      v-on:removeUser="removeAdminFromOrganization"
      :isLoading="addAdminLoading || removeAdminLoading"
    />
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import OrganizationEditionForm from "@/components/Admin/Organizations/OrganizationEditionForm";
import OrganizationUsers from "@/components/Admin/Organizations/OrganizationUsers";

export default {
  mixins: [mixin],
  components: {
    OrganizationEditionForm,
    OrganizationUsers
  },
  props: {
    organization: { type: Object, required: true }
  },
  data() {
    return {
      snackbar: false,
      organizationUuid: this.$route.params.organizationId,
      errorMessage: ""
    };
  },
  computed: {
    ...mapState({
      users: state => state.users.all,
      admins: state => state.organizations.admins,
      addAdminLoading: state => state.organizations.addAdmin.pending,
      removeAdminLoading: state => state.organizations.removeAdmin.pending
    })
  },
  methods: {
    ...mapActions("organizations", {
      updateOne: "updateOne",
      fetchAllAdmins: "fetchAllAdmins",
      addAdmin: "addAdmin",
      removeAdmin: "removeAdmin"
    }),
    ...mapActions("users", { fetchAllUsers: "fetchAll" }),
    updateOrganization(name) {
      this.updateOne({ organizationUuid: this.organizationUuid, name: name })
        .then(() => {
          this.refreshUsers();
          this.$refs.organizationEditionForm.saveCallback();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    refreshUsers() {
      this.fetchAllUsers().catch(error => {
        this.snackbar = true;
        this.errorMessage = this.errorDisplay(error);
      });
      this.fetchAllAdmins({ organizationUuid: this.organizationUuid }).catch(
        error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        }
      );
    },
    refresh() {
      this.refreshUsers();
    },
    addAdminToOrganization(uuid) {
      this.addAdmin({ organizationUuid: this.organizationUuid, userUuid: uuid })
        .then(() => {
          this.refreshUsers();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    removeAdminFromOrganization(uuid) {
      this.removeAdmin({
        organizationUuid: this.organizationUuid,
        userUuid: uuid
      })
        .then(() => {
          this.refreshUsers();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.refresh();
  }
};
</script>

<style>
</style>